import { render, staticRenderFns } from "./therapist.vue?vue&type=template&id=54fe48be"
import script from "./therapist.vue?vue&type=script&lang=js"
export * from "./therapist.vue?vue&type=script&lang=js"
import style0 from "./therapist.vue?vue&type=style&index=0&id=54fe48be&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54fe48be')) {
      api.createRecord('54fe48be', component.options)
    } else {
      api.reload('54fe48be', component.options)
    }
    module.hot.accept("./therapist.vue?vue&type=template&id=54fe48be", function () {
      api.rerender('54fe48be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personnel/therapist.vue"
export default component.exports